module.exports = __webpack_public_path__ + "static/img/minfo.74e9595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/minfo.png
// module id = wR1m
// module chunks = 12 13